"use strict";
/**
 * @module Services.Security
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var conversation_id_serialiser_1 = require("./../../conversation/conversation-id-serialiser");
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var CredentialsSerialiser = require("./../../services/authentication/credentials-serialiser");
var authenticator_request_1 = require("./authenticator-request");
/**
 * Serialiser for {@link AuthenticatorRequest}
 */
var AuthenticatorRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(AuthenticatorRequestSerialiserClass, _super);
    function AuthenticatorRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link AuthenticatorRequest} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link AuthenticatorRequest} that was read
     */
    AuthenticatorRequestSerialiserClass.prototype.read = function (bis) {
        var principal = Codec.readString(bis);
        var credentials = CredentialsSerialiser.read(bis);
        var sessionProperties = Codec.readDictionary(bis, Codec.readString);
        var proposedProperties = Codec.readDictionary(bis, Codec.readString);
        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
        return new authenticator_request_1.AuthenticatorRequest(principal, credentials, sessionProperties, proposedProperties, cid);
    };
    return AuthenticatorRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.AuthenticatorRequestSerialiserClass = AuthenticatorRequestSerialiserClass;
/**
 * The {@link AuthenticatorRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.AuthenticatorRequestSerialiser = new AuthenticatorRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/security/authenticator-request-serialiser.js
// module id = 1616
// module chunks = 1